import { addDays, addMonths, format, startOfDay, startOfMonth, startOfWeek, subMilliseconds } from 'date-fns';
import type { CalendarView } from '../../types/calendar';

/** The server treats this range as a hint and reads the person's schedule itself. */
export type SICalendarWindow = { from: string; to: string };
export type SICalendarContext = SICalendarWindow & { key: string; label: string; schedulingAvailable?: boolean | null };
export type SICalendarPrompt = { id: string; key: string; text: string };

export function buildCalendarAgentContext(key: string, view: CalendarView, date: Date): SICalendarContext {
  const start = view === 'month' ? startOfMonth(date)
    : view === 'week' ? startOfWeek(date, { weekStartsOn: 1 }) : startOfDay(date);
  const end = view === 'month' ? addMonths(start, 1) : addDays(start, view === 'week' ? 7 : view === 'agenda' ? 31 : 1);
  return {
    key, from: start.toISOString(), to: end.toISOString(),
    label: view === 'day' ? format(start, 'EEE d MMM yyyy')
      : `${format(start, 'd MMM')} – ${format(subMilliseconds(end, 1), 'd MMM yyyy')}`,
  };
}

export function calendarWindow(context: SICalendarContext | null): SICalendarWindow | undefined {
  return context ? { from: context.from, to: context.to } : undefined;
}
